import { render, staticRenderFns } from "./PurchaseOtherInvoice.vue?vue&type=template&id=6c07b866"
import script from "./PurchaseOtherInvoice.vue?vue&type=script&lang=js"
export * from "./PurchaseOtherInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports